// eslint-disable-next-line
export const ResourceStatuses = {
  ACTIVE: '1',
  EVENING: '2',
  UNPROCESSED: '3',
  INFORMATION_MISSING: '4',
  WARNING: '5',
  NOT_INTERESTED: '6',
  IMPORTED: '9',
  DUPLICATE: '10',
  NOT_QUALIFIED: '11',
  TEMPORARY: '12',
  PERMANENT: '13',
  NEEDS: '14',
  INTERNSHIP: '15',
  TO_CUSTOMER: '16',
  COMPLETED: '17',
  SELF_RESIGN: '18',
  PERSONAL_RESIGN: '19',
  EMPLOYED_WITH_SUBSIDY: '20',
  UNBOOKED: '21',
  PERMANENT_EMPLOYED_WITH_SUBSIDY: '22',
};
